import { History } from "lucide-react";
import type { LedgerEntry } from "./types";

export type CustomerMovementFilter = "All" | LedgerEntry["description"];

const movementFilters = ["All", "Record", "Session", "Workshop", "Payment"] as const;

const movementFilterLabel = (filter: CustomerMovementFilter) => {
  if (filter === "All") return "Tümü";
  if (filter === "Record") return "Kayıt";
  if (filter === "Session") return "Seans";
  if (filter === "Workshop") return "Atölye";
  if (filter === "Payment") return "Ödeme";
  return "Düzeltme";
};

export function CustomerHistoryToolbar({
  movementFilter,
  onMovementFilterChange,
  onOpenSummary
}: {
  movementFilter: CustomerMovementFilter;
  onMovementFilterChange: (filter: CustomerMovementFilter) => void;
  onOpenSummary: () => void;
}) {
  return (
    <div className="customer-history-toolbar">
      <div className="segmented movement-filter">
        {movementFilters.map((filter) => (
          <button
            type="button"
            key={filter}
            className={movementFilter === filter ? "active" : ""}
            onClick={() => onMovementFilterChange(filter)}
          >
            {movementFilterLabel(filter)}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="button ghost compact customer-history-trigger"
        onClick={onOpenSummary}
      >
        <History size={14} /> Özetle
      </button>
    </div>
  );
}
